"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAsyncFunction = void 0;
const get_type_1 = require("./get-type");
exports.isAsyncFunction = (value) => get_type_1.getType(value) === "[object AsyncFunction]";
//# sourceMappingURL=is-async-function.js.map